export const UX_WRITING = {
  REGISTER_DATASET: 'New dataset',
  STEP_ONE_TITLE: 'General information',
  STEP_TWO_TITLE: 'Source details',
  STEP_THREE_TITLE: 'Data schema',
  STEP_FOUR_TITLE: 'Configure ingestion',
};
